import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Index from "@views/home/Index";
import Search from "@views/shop/GoodSearch";
import Category from "@views/shop/GoodsClass";
import ShoppingCart from "@views/shop/ShoppingCart";
import GoodsList from "@views/shop/GoodsList";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin from "@libs/login";
import Loading from "@views/Loading";

// import { postOrderIsVip} from "@api/order";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/video/Prview",
      name: "Prview",
      meta: {
        title: "首页",
        keepAlive: false
      },
      component: () => import("@views/video/Prview.vue")
    },
    {
      path: "/shop/storeList/:gonames?",
      name: "StoreList",
      meta: {
        title: "门店列表",
        keepAlive: false
      },
      component: () => import("@views/shop/StoreList.vue")
    },
    {
      path: "/",
      name: "Index",
      meta: {
        title: "首页",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff"
      },
      component: Index
    },
    {
      path: "/category/:pid?",
      name: "GoodsClass",
      meta: {
        title: "产品分类",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff"
      },
      component: Category
    },
    {
      path: "/collection",
      name: "GoodsCollection",
      meta: {
        title: "收藏商品",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/shop/GoodsCollection.vue")
    },

    {
      path: "/foot",
      name: "GoodsFoot",
      meta: {
        title: "收藏商品",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/shop/GoodsFoot.vue")
    },
    {
      path: "/search",
      name: "GoodSearch",
      meta: {
        title: "搜索商品",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: Search
    },
    {
      path: "/news_detail/:id",
      name: "NewsDetail",
      meta: {
        title: "新闻详情",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsDetail.vue")
    },
    {
      path: "/news_list",
      name: "NewsList",
      meta: {
        title: "新闻",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsList.vue")
    },
    {
      path: "/evaluate_list/:id",
      name: "EvaluateList",
      meta: {
        title: "商品评分",
        keepAlive: true,
        auth: true
      },
      component: () => import("@views/shop/EvaluateList.vue")
    },
    {
      path: "/goods_evaluate/:id",
      name: "GoodsEvaluate",
      meta: {
        title: "商品评价",
        keepAlive: true,
        auth: true
      },
      component: () => import("@views/shop/GoodsEvaluate.vue")
    },
    {
      path: "/promotion",
      name: "GoodsPromotion",
      meta: {
        title: "促销单品",
        keepAlive: false
      },
      component: () => import("@views/shop/GoodsPromotion.vue")
    },
    {
      path: "/hot_new_goods/:type",
      name: "HotNewGoods",
      meta: {
        title: "热门榜单",
        keepAlive: false
      },
      component: () => import("@views/shop/HotNewGoods.vue")
    },
    {
      path: "/religion",
      name: "ReligionIndex",
      meta: {
        title: "功德榜",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/religion/religionIndex.vue")
    },
    {
      path: "/contribution/:id",
      name: "ContributionIndex",
      meta: {
        title: "智慧祈福宝",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/religion/contributionIndex.vue")
    },
    {
      path: "/contribution1/:id",
      name: "ContributionIndex1",
      meta: {
        title: "智慧祈福宝",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/religion/contributionIndex1.vue")
    },
    {
      path: "/detail/:id",
      name: "GoodsCon",
      meta: {
        title: "智慧祈福宝",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/shop/GoodsCon.vue")
    },
    {
      path: "/walldetail/:id",
      name: "BuddhaWall",
      meta: {
        title: "智慧祈福宝",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/shop/BuddhaWall.vue")
    },
    {
      path: "/candle/:id",
      name: "Candle",
      meta: {
        title: "智慧祈福宝",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/shop/Candle.vue")
    },
    {
      path: "/cart",
      name: "ShoppingCart",
      meta: {
        title: "购物车",
        keepAlive: true,
        footer: true,
        auth: true
      },
      component: ShoppingCart
    },
    {
      path: "/goods_list",
      name: "GoodsList",
      meta: {
        title: "商品列表",
        keepAlive: true
      },
      component: GoodsList
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Login.vue")
    },
    ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: true
      },
      component: Loading
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB"
      },
      component: NotDefined
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  }
});

const { back, replace } = router;

router.back = function() {
  console.log("====back======");
  this.isBack = true;
  back.call(router);
};
router.replace = function(...args) {
  console.log("====back======");
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  const { title, backgroundColor, footer, home, auth } = to.meta;
  console.log(to.name, form.name);
  if (auth === true && !$store.state.app.token) {
    if (form.name === "Login") return;
    return toLogin(true, to.fullPath);
  }
  document.title = title || process.env.VUE_APP_NAME || "智慧祈福宝";
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("SHOW_HOME") : $store.commit("SHOW_HOME");
  // home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  console.log("333333333333333333111to.fullPath===="+to.fullPath+"==========="+form.name)
  // if('/'==to.fullPath){
  //   next({path: '/detail/95'})
  // }else{
  //   next();
  // }

  next();




  // /detail/95
  // if (auth) {
  //   $store.dispatch("USERINFO").then(() => {
  //     next();
  //   });
  // } else next();
});

export default router;
